import { useState, useEffect } from 'react'
import DashboardLayout from '../../common/DashboardLayout'
import { Link } from 'react-router-dom'
import TeacherServices from '../../../services/TeacherServices'
import QuizServices from '../../../services/QuizServices'

const SchoolTeacherDashboard = () => {

    const [courseStatus, setCourseStatus] = useState({
      isCompleted: false,
      inProgress: false,
      progress: null
    });
    const [isLoading, setIsLoading] = useState(true);
    const [courseVideos, setCourseVideos] = useState([]);

    useEffect(() => {
      const fetchCourseStatus = async () => {
        try {
          setIsLoading(true);
          const user = JSON.parse(localStorage.getItem("user"));
          const teacherId = user?._id || user?.id;
          
          // Fetch course videos and check completion status
          try {
            const videosResponse = await TeacherServices.getVideosWithQuiz(teacherId);
            if (videosResponse) {
              if (videosResponse.is_quiz_retake) {
                setCourseStatus(prev => ({ ...prev, isCompleted: true }));
              }
              if (videosResponse.videos) {
                setCourseVideos(videosResponse.videos);
              }
            }
          } catch (error) {
            console.log("Course not completed or error:", error);
          }

          // Check progress
          try {
            const progressResponse = await QuizServices.checkProcess(teacherId);
            if (progressResponse && (progressResponse.currentGroupIndex !== 0 || progressResponse.currentVideoIndex !== 0)) {
              setCourseStatus(prev => ({ 
                ...prev, 
                inProgress: true,
                progress: progressResponse
              }));
            }
          } catch (error) {
            console.log("No progress found:", error);
          }
        } catch (error) {
          console.error("Error fetching course status:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchCourseStatus();
    }, []);

    const getTrainingPath = () => {
      const user = JSON.parse(localStorage.getItem("user"));
      const teacherId = user?._id || user?.id || "";
      if (teacherId) {
        return `/teachertest/mcq-test?teacher_id=${encodeURIComponent(teacherId)}`;
      }
      return "/teachertest/mcq-test";
    };

    const trainingPath = getTrainingPath();

    return (
        <DashboardLayout 
            role={2} 
            activeMenu="Dashboard"
            layoutType="topnav"
        >
                                {isLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-3">Loading course information...</p>
                                    </div>
                                ) : (
                                    <>
                                        {/* Dashboard Grid */}
                                        <div className="row justify-content-center">
                                            <div className="col-lg-4 col-md-6 d-flex">
                                                <div className="card dash-info flex-fill">
                                                    <div className="card-body">
                                                        <h5>Course Status</h5>
                                                        <h2>
                                                            {courseStatus.isCompleted ? (
                                                                <span style={{ color: 'green' }}>Completed</span>
                                                            ) : courseStatus.inProgress ? (
                                                                <span style={{ color: 'orange' }}>In Progress</span>
                                                            ) : (
                                                                <span style={{ color: 'blue' }}>Not Started</span>
                                                            )}
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 d-flex">
                                                <div className="card dash-info flex-fill">
                                                    <div className="card-body">
                                                        <h5>Total Modules</h5>
                                                        <h2>{courseVideos.length || 0}</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 d-flex">
                                                <div className="card dash-info flex-fill">
                                                    <div className="card-body">
                                                        <h5>Progress</h5>
                                                        <h2>
                                                            {courseStatus.progress ? (
                                                                `Video ${courseStatus.progress.currentVideoIndex + 1}/${courseVideos.length}`
                                                            ) : courseStatus.isCompleted ? (
                                                                '100%'
                                                            ) : (
                                                                '0%'
                                                            )}
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Dashboard Grid */}
                                        
                                        {/* Course Title */}
                                        <div className="dashboard-title mt-4">
                                            <h4>Active Shooter and Emergency Protocols Certification</h4>
                                            <p className="text-muted">Select a module below to begin or continue your training</p>
                                        </div>

                                        {/* Course Modules List - Always Visible */}
                                        {courseVideos.length > 0 && (
                                            <div className="card mt-4">
                                                <div className="card-header d-flex justify-content-between align-items-center">
                                                    <h5 className="mb-0">Course Modules ({courseVideos.length})</h5>
                                                    <div className="d-flex gap-2">
                                                        {courseStatus.isCompleted && (
                                                            <Link to="/my-certifications" className="btn btn-sm btn-success">
                                                                <i className="bx bx-certificate me-1"></i>
                                                                View Certificates
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="table-responsive">
                                                            <table className="table table-hover" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                                <colgroup>
                                                                    <col style={{ width: '5%' }} />
                                                                    <col style={{ width: '55%' }} />
                                                                    <col style={{ width: '10%' }} />
                                                                    <col style={{ width: '15%' }} />
                                                                    <col style={{ width: '15%' }} />
                                                                </colgroup>
                                                                <thead>
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>Module Name</th>
                                                                        <th>Quizzes</th>
                                                                        <th>Status</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {courseVideos.map((video, videoIndex) => {
                                                                        const isCompleted = courseStatus.isCompleted || 
                                                                            (courseStatus.progress && courseStatus.progress.currentVideoIndex > videoIndex);
                                                                        const isCurrent = courseStatus.progress && 
                                                                            courseStatus.progress.currentVideoIndex === videoIndex;
                                                                        
                                                                        return (
                                                                            <tr key={videoIndex}>
                                                                                <td><strong>{videoIndex + 1}</strong></td>
                                                                                <td style={{
                                                                                    wordWrap: 'break-word',
                                                                                    overflowWrap: 'break-word',
                                                                                    wordBreak: 'break-word',
                                                                                    whiteSpace: 'normal',
                                                                                    overflow: 'hidden',
                                                                                    verticalAlign: 'top',
                                                                                    padding: '8px'
                                                                                }}>
                                                                                    <strong>{video.description || `Module ${videoIndex + 1}`}</strong>
                                                                                    {video.quizzes && video.quizzes.length > 0 && (
                                                                                        <small className="d-block text-muted mt-1">
                                                                                            {video.quizzes.length} quiz{video.quizzes.length > 1 ? 'zes' : ''} included
                                                                                        </small>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {video.quizzes ? video.quizzes.length : 0}
                                                                                </td>
                                                                                <td>
                                                                                    {isCompleted ? (
                                                                                        <span className="badge bg-success">Completed</span>
                                                                                    ) : isCurrent ? (
                                                                                        <span className="badge bg-warning">In Progress</span>
                                                                                    ) : (
                                                                                        <span className="badge bg-secondary">Not Started</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {courseStatus.isCompleted ? (
                                                                                        <Link 
                                                                                            to={trainingPath} 
                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                        >
                                                                                            <i className="bx bx-refresh me-1"></i>
                                                                                            Review
                                                                                        </Link>
                                                                                    ) : (
                                                                                        <Link 
                                                                                            to={trainingPath} 
                                                                                            className="btn btn-sm btn-primary"
                                                                                        >
                                                                                            <i className="bx bx-play-circle me-1"></i>
                                                                                            {isCurrent ? 'Continue' : 'Start'}
                                                                                        </Link>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
        </DashboardLayout>
    )
}

export default SchoolTeacherDashboard
